export enum FlowStatus{
    OK = "OK",
    ACTIVE= "ACTIVE",
}